import { render, staticRenderFns } from "./TrademarkResponsibleList.vue?vue&type=template&id=c254c300&"
import script from "./TrademarkResponsibleList.vue?vue&type=script&lang=js&"
export * from "./TrademarkResponsibleList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkResponsibleList.vue?vue&type=style&index=0&id=c254c300&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports